import React from 'react';
import { Row, Col } from 'antd';
import { GeneralInformationSummary } from '../GeneralInformationSummary';
import { ReportsAlreadyCreated } from './ReportsAlreadyCreated';

export function Reports() {
	return (
		<Row gutter={[0, 40]}>
			<Col span={24}>
				<GeneralInformationSummary />
			</Col>
			<Col span={24}>
				<ReportsAlreadyCreated />
			</Col>
		</Row>
	);
}
